import Action, { ActionFileShow, ActionType } from '../Actions/ActionTypes'
import { Reducer } from 'redux'
import FileState from '../State/FileState'
import { isBookmarked } from '../../../../../../local/storage'

const actionFileShow = (oldState: FileState, action: Action): FileState => {
    let data = (action as ActionFileShow).data
    return { ...oldState, data: data , saved : isBookmarked(data?.id ?? -1)}
}

const actionFileSave = (oldState: FileState, action: Action): FileState => {
    return { ...oldState, saved : !oldState.saved}
}

type Process = (oldState: FileState, action: Action) => FileState

export const FileReducer: Reducer<FileState, Action> = (state: FileState = { data: undefined , saved : false}, action: Action): FileState => {

    let actionMap = new Map<ActionType, Process>()
    actionMap.set(ActionType.FILE_SHOW, actionFileShow)
    actionMap.set(ActionType.FILE_SAVE, actionFileSave)

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}


